export function parsePiiFoundValue(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value
      .map((entry) => String(entry ?? '').trim())
      .filter(Boolean);
  }

  if (typeof value === 'string') {
    return value
      .split(/[;,]/)
      .map((entry) => entry.trim())
      .filter(Boolean);
  }

  return [];
}

export function serializePiiFoundValue(values: string[]): string {
  return values
    .map((entry) => String(entry ?? '').trim())
    .filter(Boolean)
    .join(';');
}

export function formatPiiFoundDisplay(value: unknown): string {
  const parsed = parsePiiFoundValue(value);
  return parsed.length > 0 ? parsed.join(', ') : '';
}
